import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { OutsideClick } from '../../../../shared/directives/outside-click/outside-click.directive';
import { DashboardPeriodOption } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-period-filter',
  standalone: true,
  imports: [FormsModule, IconComponent, OutsideClick],
  templateUrl: './dashboard-period-filter.component.html',
})
export class DashboardPeriodFilterComponent {

  @Input({ required: true })
  public options: DashboardPeriodOption[] = [];

  @Input({ required: true })
  public selectedValue: string = '';

  @Input()
  public shortDisplay: boolean = false;

  @Output()
  public readonly selectedValueChange = new EventEmitter<string>();

  public isOpen: boolean = false;

  public get selectedLabel(): string {
    const option = this.options.find((item) => item.value === this.selectedValue);

    if (!option)
      return 'Selecionar';

    if (this.shortDisplay && option.value.includes('year'))
      return 'Ano';

    return option.label;
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
  }

  public close(): void {
    this.isOpen = false;
  }

  public select(value: string): void {
    this.selectedValue = value;
    this.selectedValueChange.emit(value);
    this.close();
  }

}
